import React from 'react';
import moment from 'moment';

moment.locale('id');

const TOTAL_COLS = 16;

const formatRupiah = (value) =>
  `Rp.${Number(value || 0).toLocaleString('id-ID')}`;

const formatDate = (value) =>
  value ? moment(value).format('D MMMM YYYY') : '-';

const getCustomerName = (row) => {
  if (row.attendeeName) return row.attendeeName;
  const first = row.firstName || '';
  const last = row.lastName || '';
  const joined = `${first} ${last}`.trim();
  return joined || '-';
};

const getDescription = (row) => {
  const parts = [row.category, row.productName, row.description].filter(
    Boolean,
  );
  return parts.length ? parts.join(' — ') : '-';
};

const getBankRekening = (row) => {
  if (!row.bankName && !row.bankAccountNumber) return '-';
  return `${row.bankName || '-'} - ${row.bankAccountNumber || '-'}`;
};

const SummaryRows = ({ summary }) => {
  const grandTotalInvoice = summary?.grandTotalInvoice || 0;
  const grandTotalPayment = summary?.grandTotalPayment || 0;
  const sumTotalInvoice = summary?.sumTotalInvoice || 0;
  const sumTotalPayment = summary?.sumTotalPayment || 0;

  return (
    <>
      <tr>
        <td colSpan={TOTAL_COLS - 1}>
          <span className="float-right font-weight-bold">
            Sum Total Invoice
          </span>
        </td>
        <td style={{ textAlign: 'right' }}>{formatRupiah(sumTotalInvoice)}</td>
      </tr>
      <tr>
        <td colSpan={TOTAL_COLS - 1}>
          <span className="float-right font-weight-bold">
            Sum Total Payment
          </span>
        </td>
        <td style={{ textAlign: 'right' }}>{formatRupiah(sumTotalPayment)}</td>
      </tr>
      <tr>
        <td colSpan={TOTAL_COLS - 1}>
          <span className="float-right font-weight-bold">
            Grand Total Invoice
          </span>
        </td>
        <td style={{ textAlign: 'right' }}>
          {formatRupiah(grandTotalInvoice)}
        </td>
      </tr>
      <tr>
        <td colSpan={TOTAL_COLS - 1}>
          <span className="float-right font-weight-bold">
            Grand Total Payment
          </span>
        </td>
        <td style={{ textAlign: 'right' }}>
          {formatRupiah(grandTotalPayment)}
        </td>
      </tr>
    </>
  );
};

const HeaderRow = () => (
  <tr>
    <td className="font-weight-bold">No.</td>
    <td className="font-weight-bold">Nama Customer</td>
    <td className="font-weight-bold">Deskripsi</td>
    <td className="font-weight-bold">No. Invoice</td>
    <td className="font-weight-bold">Admission</td>
    <td className="font-weight-bold">PIC</td>
    <td className="font-weight-bold">Tgl. Invoice</td>
    <td className="font-weight-bold">Nominal</td>
    <td className="font-weight-bold">Discount</td>
    <td className="font-weight-bold">Qty</td>
    <td className="font-weight-bold">Total Nominal</td>
    <td className="font-weight-bold">Nominal Payment</td>
    <td className="font-weight-bold">Receipt Number</td>
    <td className="font-weight-bold">Tanggal Mutasi</td>
    <td className="font-weight-bold">Bank Rekening</td>
    <td className="font-weight-bold">Tag</td>
  </tr>
);

const AccountingSalesReportTable = ({ rows, summary }) => {
  return (
    <table id="table-to-xls" className="table table-bordered">
      <tbody>
        <SummaryRows summary={summary} />
        <HeaderRow />
        {rows.map((row, index) => {
          const qty = row.qty || 1;
          const nominal = (row.price || 0) * qty;
          const discount = nominal - (row.finalPrice || 0);
          const totalNominal = nominal - discount;
          const rowKey = `${row.paymentId || 'np'}-${
            row.salesId || 'ns'
          }-${index}`;

          return (
            <tr key={rowKey}>
              <td>{index + 1}</td>
              <td>{getCustomerName(row)}</td>
              <td>{getDescription(row)}</td>
              <td>{row.invoiceNumber || '-'}</td>
              <td>{row.createdBy || '-'}</td>
              <td>{row.handledBy || '-'}</td>
              <td>{formatDate(row.invoiceCreatedAt)}</td>
              <td style={{ textAlign: 'right' }}>{formatRupiah(nominal)}</td>
              <td style={{ textAlign: 'right' }}>{formatRupiah(discount)}</td>
              <td style={{ textAlign: 'center' }}>{qty}</td>
              <td style={{ textAlign: 'right' }}>
                {formatRupiah(totalNominal)}
              </td>
              <td style={{ textAlign: 'right' }}>
                {formatRupiah(row.paymentNominal)}
              </td>
              <td>{row.receiptNumber || '-'}</td>
              <td>
                {row.mutationDate
                  ? formatDate(row.mutationDate)
                  : formatDate(row.confirmedAt)}
              </td>
              <td>{getBankRekening(row)}</td>
              <td>{row.tag || '-'}</td>
            </tr>
          );
        })}
        <SummaryRows summary={summary} />
      </tbody>
    </table>
  );
};

export default AccountingSalesReportTable;
